"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _coreThemes = require("@vfuk/core-themes");

var _coreFunctionalContentBlock = require("@vfuk/core-functional-content-block");

var _coreBaseProps = require("@vfuk/core-base-props");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ContentBlockWithVideo = function ContentBlockWithVideo(_ref) {
  var appearance = _ref.appearance,
      heading = _ref.heading,
      content = _ref.content,
      videoId = _ref.videoId,
      videoTitle = _ref.videoTitle,
      _ref$videoPosition = _ref.videoPosition,
      videoPosition = _ref$videoPosition === void 0 ? 'center' : _ref$videoPosition,
      primaryButton = _ref.primaryButton,
      secondaryButton = _ref.secondaryButton,
      footnote = _ref.footnote,
      localTheme = _ref.localTheme,
      id = _ref.id,
      dataSelectorPrefix = _ref.dataSelectorPrefix,
      dataAttributes = _ref.dataAttributes;
  var componentName = 'ContentBlockWithVideo';
  var contentBlockTheme = (0, _coreThemes.useLocalTheme)(componentName, _coreFunctionalContentBlock.functionalContentBlockTheme, localTheme);
  return /*#__PURE__*/_react["default"].createElement(_coreFunctionalContentBlock.FunctionalContentBlock, {
    appearance: appearance,
    heading: heading,
    content: content,
    primaryButton: primaryButton,
    secondaryButton: secondaryButton,
    footnote: footnote,
    mediaPosition: videoPosition,
    localTheme: contentBlockTheme,
    id: id,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix),
    dataAttributes: _objectSpread({
      'data-component-name': componentName
    }, dataAttributes)
  }, /*#__PURE__*/_react["default"].createElement(_coreFunctionalContentBlock.ContentVideo, {
    videoPosition: videoPosition,
    videoTitle: videoTitle,
    videoId: videoId,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'video')
  }));
};

ContentBlockWithVideo.displayName = "ContentBlockWithVideo";
var _default = ContentBlockWithVideo;
exports["default"] = _default;
//# sourceMappingURL=ContentBlockWithVideo.js.map